import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import LoginDialog from "../Login/LoginCard";
import SEOHead from "../SEO/SEOHead";
import "./Layout.css";

function Layout() {
  const location = useLocation();
  const navigate = useNavigate();

  const shouldHideHeaderFooter = () => {
    const hidePatterns = [/^\/login$/, /^\/[^/]+\/ebook\/download\/[^/]+$/];
    return hidePatterns.some((pattern) => pattern.test(location.pathname));
  };

  const handleLoginSuccess = (userName) => {
    navigate("/");
    window.location.reload();
  };

  // Website schema for structured data
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    url: "https://myburgo.com",
    name: "MyBurgo",
    description:
      "MyBurgo is India's comprehensive parenting app offering expert guidance, interactive workshops, personalized resources, and community support for parents and pregnant women.",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://myburgo.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <div className="layout-container">
      {/* Global SEO component */}
      <SEOHead schema={websiteSchema} />

      {/* Conditionally render header and footer based on the current path */}
      {!shouldHideHeaderFooter() && (
        <Header handleLoginSuccess={handleLoginSuccess} />
      )}

      <main className="content">
        <Outlet />
      </main>

      <a
        href="https://api.whatsapp.com/send?phone=917710048212&text=Hi%20can%20you%20please%20help%20me%20with%20..."
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact us on WhatsApp"
      >
        <i className="fab fa-whatsapp my-float" aria-hidden="true"></i>
      </a>

      {!shouldHideHeaderFooter() && <Footer />}
    </div>
  );
}

export default Layout;
